<template>
  <div class="terminal-container">
    <div class="terminal-content">
      <TerminalText :encrypted="encrypted" />
    </div>
    <div class="terminal-text">
      <textarea
        v-model="text"
        class="blinking-cursor"
        autofocus
        @keyup.enter="submit"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TerminalText from './TerminalText'

export default {
  name: 'TerminalContent',

  components: { TerminalText },

  props: {
    encrypted: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      text: '',
    }
  },

  computed: {
    ...mapGetters({
      currentEpisode: 'auth/currentEpisode',
    }),
  },

  methods: {
    ...mapActions({
      loginUser: 'auth/loginUser',
      showPermissionPending: 'auth/showPermissionPending',
    }),

    submit() {
      const form = {
        username: 'backdoor-terminal',
        password: this.text.slice(0, -1), // removes enter char
        backdoor: true,
      }

      this.text = ''

      if (this.currentEpisode < 4) {
        return this.showPermissionPending()
      }

      this.loginUser(form)
        .then(() => {
          this.$router.push({ name: 'TerminalGranted', params: { encrypted: false } })
        })
        .catch(() => this.showPermissionPending())
    },
  },
}
</script>

<style lang="postcss" scoped>
.terminal {
  &-container {
    @apply h-full;
  }

  &-content {
    @apply h-2/3 overflow-scroll text-center;
  }

  &-text {
    height: 138px;
    @apply h-1/3;
  }
}

img {
  max-width: 10000px;
}

.blinking-cursor {
  font-family: 'input-mono';
  resize: none;
  -webkit-animation: 1s blink step-end infinite;
  -moz-animation: 1s blink step-end infinite;
  -ms-animation: 1s blink step-end infinite;
  -o-animation: 1s blink step-end infinite;
  animation: 1s blink step-end infinite;
  @apply bg-dark-black text-blue-lighter p-4 border border-blue-lighter outline-none h-full w-full;
}

@keyframes "blink" {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}

@-moz-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}

@-webkit-keyframes "blink" {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}

@-ms-keyframes "blink" {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}

@-o-keyframes "blink" {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}
</style>
